import { hueOf } from "../presence/presence";
import { initialsOf } from "../ui/Avatar";

/** tinted pill/tile background for a colour: `color-mix(...)`. */
export const tint = (color, pct = 15) => `color-mix(in srgb, ${color} ${pct}%, transparent)`;
export const pillStyle = (color) => ({ background: tint(color), color });

/** Per-name avatar colours (same hue function the presence avatars use). */
export const avatarStyle = (name) => {
  const h = hueOf(name);
  return { background: `hsl(${h} 70% 50% / 0.2)`, color: `hsl(${h} 75% 62%)` };
};
export { initialsOf };

export const isArabic = (text) => /[؀-ۿ]/.test(String(text || ""));

/** "12m ago", "3h ago", "Yesterday", "4d ago", else a short date. */
export const relativeTime = (value) => {
  const t = new Date(value).getTime();
  if (!t) return "";
  const diff = Date.now() - t;
  const min = Math.floor(diff / 60000);
  if (min < 1) return "Just now";
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day === 1) return "Yesterday";
  if (day < 7) return `${day}d ago`;
  return new Date(t).toLocaleDateString(undefined, { day: "numeric", month: "short" });
};

export const fullDate = (value) =>
  new Date(value).toLocaleString(undefined, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

/** Short, stable reference for a request ("REQ-3FA91C"). */
export const refOf = (id) => `REQ-${String(id).slice(-6).toUpperCase()}`;

export const firstNameOf = (name) => String(name || "").trim().split(/\s+/)[0] || "";

/** "EMPLOYEE" -> "Employee". */
export const prettyType = (v) => (v ? String(v).charAt(0) + String(v).slice(1).toLowerCase().replace(/_/g, " ") : "—");
